'use strict';

var helpers = require('./helpers.js');
var subscriptions = require('./subscriptions.js');

/**
 * @deprecated Use AuthLoginByOtacHelper. Remove on next major
 */
const openAuthLoginUrlByOtac = (params) => {
    if (typeof window === 'undefined')
        return null;
    const getSilentAuthModalParameters = (width, height) => {
        const getSilentAuthModalPosition = (width, height) => {
            if (typeof window === 'undefined')
                return null;
            // Fixes dual-screen position                             Most browsers      Firefox
            const screenDualLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const screenDualTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
            const screenWidth = window.innerWidth || document.documentElement.clientWidth || window.screen.width;
            const screenHeight = window.innerHeight || document.documentElement.clientHeight || window.screen.height;
            const top = (screenHeight - height) / 2 + screenDualTop;
            const left = (screenWidth - width) / 2 + screenDualLeft;
            return {
                top,
                left,
            };
        };
        const modalPosition = getSilentAuthModalPosition(width, height);
        return `width=${width}, height=${height}, top=${modalPosition ? modalPosition.top : 0}, left=${modalPosition ? modalPosition.left : 0}`;
    };
    const { otac, hint, prefix, webPath, type, width = 430, height = 600, onSuccess, onError = () => { } } = params;
    const isNewWindow = ['modal', 'tab'].includes(type);
    const target = isNewWindow ? '_blank' : '_self';
    const features = ['modal'].includes(type) ? getSilentAuthModalParameters(width, height) : undefined;
    const loginUrl = helpers.getLoginUrl({
        otac,
        hint,
        prefix,
        webPath,
        loginType: 'otac',
        isNewWindow,
        // Это нужно для логина под новым юзером, даже если мы уже залогинены под каким-то другим
        prompt: 'login',
    });
    subscriptions.subscribeOnLoginSuccess(onSuccess);
    // Хак для сафари. Открытие окна происходит в синхронном коде
    setTimeout(() => {
        const handle = window.open(loginUrl, target, features);
        if (!handle) {
            onError(new Error('Modal window was blocked by browser'));
        }
    }, 0);
};

exports.openAuthLoginUrlByOtac = openAuthLoginUrlByOtac;
//# sourceMappingURL=openAuthLoginUrlByOtac.js.map
